export const defaultLenderHubResourceShareFilters = {
  page: 1,
  size: 50,
  sortBy: 2,
};
